import { render, staticRenderFns } from "./pt.svg?vue&type=template&id=7e7cf2c6&"
var script = {}


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports